export const userMenu = (props) => [
    {
        label: 'Dashboard',
        icon: 'pi pi-chart-bar',
        command:()=> props.history.push('/user')
    }
];